import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    EntityCacheDispatcher,
    EntityCollectionServiceElementsFactory,
    HttpUrlGenerator,
    Logger,
    QueryParams
} from '@ngrx/data';
import { Observable } from 'rxjs/Observable';
import { WebsocketBrokerService } from '../../../../core/services/websocket-broker.service';
import { WebSocketEntityCollectionServiceBase } from '../../../../state/entity/web-socket-entity-collection-service-base';
import { MissedAppointmentsDashboardEntityDataServiceBase } from './missed-appointments-dashboard-entity-data-service.base';
import {
    missedAppointmentsDashboardEntityMetadata, MissedAppointmentsDashboardQueryFilter
} from './missed-appointments-dashboard.entity';

@Injectable()
export class MissedAppointmentsDashboardService extends WebSocketEntityCollectionServiceBase<any> {

    refreshing$: Observable<boolean>;
    queryFilter$: Observable<MissedAppointmentsDashboardQueryFilter>;
    totalMissedCount$: Observable<number>;

    constructor(private http: HttpClient,
                private serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super(missedAppointmentsDashboardEntityMetadata.entityName, serviceElementsFactory);
        this.refreshing$ = this.selectors$['refreshing$'];
        this.queryFilter$ = this.selectors$['queryFilter$'];
        this.totalMissedCount$ = this.selectors$['totalMissedCount$'];
    }
}
/**
 * This is the data service NgRx Data will use to call from effects to make the actual calls to the backend.
 */
@Injectable()
export class MissedAppointmentsDashboardEntityDataService extends MissedAppointmentsDashboardEntityDataServiceBase<any> {
    constructor(http: HttpClient,
                httpUrlGenerator: HttpUrlGenerator,
                logger: Logger,
                public entityCacheDispatcher: EntityCacheDispatcher,
                public websocketBrokerService: WebsocketBrokerService) {
        super(http, httpUrlGenerator, logger, entityCacheDispatcher, websocketBrokerService,
            'MissedAppointmentsDashboard', 'missed-dashboard/');
        logger.log('Created custom Missed Appointments Dashboard');
    }

    subscribeWebSocketJob(parameters: any | QueryParams): void {
        this.subscribeWebSocketJobWithBody({parameters});
    }

    refreshWebSocketJob(parameters: any | QueryParams): void {
        this.refreshWebSocketJobWithBody({parameters});
    }
}
